import * as z from 'zod';
import { POLLS_INPUT_MAX_LENGTH } from 'features/polls/constants';

export const quizSettingsSchema = z.object({
  title: z.string().min(1, 'Title is required'),
  timingMode: z.enum(['quiz', 'question']),
  timeLimitSeconds: z.coerce.number().min(1, 'Time limit must be greater than 0'),
  passingScorePercentage: z.string().transform((val, ctx) => {
    if (val === '') {
      return undefined;
    }

    const n = Number(val);
    if (!Number.isInteger(n) || n < 0 || n > 100) {
      ctx.addIssue({
        code: 'custom',
        message: 'Must be an integer between 0 and 100',
      });

      return z.NEVER;
    }

    return n;
  }),
});

export const quizChoiceSchema = z.object({
  text: z
    .string()
    .min(1, 'Choice text is required')
    .max(POLLS_INPUT_MAX_LENGTH, 'Choice text must be less than 255 characters'),
  correct: z.boolean(),
});

export const quizQuestionSchema = z.object({
  text: z.string().min(1, 'Question text is required'),
  multipleChoices: z.boolean(),
  choices: z
    .array(quizChoiceSchema)
    .min(2, 'At least 2 choices are required')
    .refine((choices) => choices.some((choice) => choice.correct), {
      error: 'At least one choice must be marked as correct',
    }),
});

export const quizSchema = z.object({
  title: z.string().min(1, 'Quiz title is required'),
  timeLimitSeconds: z.number().positive('Time limit must be positive'),
  timingMode: z.enum(['quiz', 'question']),
  showCorrectAnswers: z.boolean(),
  passingScorePercentage: z.number().int().min(0).max(100).optional(),
  questions: z.array(quizQuestionSchema).min(1, 'At least one question is required'),
});
